import React, { useContext, useEffect, useState } from "react";
import { URL_BASE } from "../../../App";
import MyContext from "../../../StoreContext";

/**
 * El componente de gmail se encarga de mostrar la imagen correspondiente al
 * rubro elegido, el canal y mensaje selecionado.
 * En este componente tambien encontramos un setTimeout para hacer el cambio
 * a la imagen de cuando se "abre" el correo con el mensaje enviado
 *
 * La estrutura en el static storage para cumplir con esta logica en la siguiente:
 * industria -> canal -> mensaje
 * eje: retail/gmail/address
 */
const Gmail = () => {
  const { industry, channel, message, showResponse } = useContext(MyContext);
  const [first, setFirst] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFirst(true);
      console.log("change the image in gmail ");
    }, 1500);
    return () => {
      clearTimeout(timer);
      setFirst(false);
      console.log("change the image in gmail out");
    };
  }, [message]);

  if (message) {
    return (
      <img
        src={`${URL_BASE}/${industry}/${channel}/${message}/${
          !showResponse
            ? !first
              ? message
              : message + "2"
            : message + "_response"
        }.webp`}
        alt='gmail max'
        className='phoneDimension'
      />
    );
  }

  return (
    <img
      src={`${URL_BASE}/${industry}/${channel}/${channel}_base.webp`}
      alt='gmail max'
      className='phoneDimension'
    />
  );
};

export default Gmail;
